import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { GrcCard } from "./shared";

const BANDS = [
  { label: "0–10 Cr", color: "#388E3C" },
  { label: "10–50 Cr", color: "#FBC02D" },
  { label: "50–150 Cr", color: "#F57C00" },
  { label: "150–250 Cr", color: "#D32F2F" },
];

function bandIndexFromText(text) {
  if (!text) return null;
  const m = String(text).match(/(\d+)\s*[-–]\s*(\d+)/);
  if (!m) return null;
  const lo = parseInt(m[1], 10);
  if (lo >= 150) return 3;
  if (lo >= 50) return 2;
  if (lo >= 10) return 1;
  return 0;
}

const NeedleOverlay = ({ idx }) => {
  // semicircle 180° → 0°, needle points to band midpoint
  const angle = 180 - (idx + 0.5) * 45;
  const rad = (angle * Math.PI) / 180;
  const cx = 100, cy = 104, len = 52;
  const x = cx + len * Math.cos(rad);
  const y = cy - len * Math.sin(rad);
  return (
    <svg
      viewBox="0 0 200 112"
      preserveAspectRatio="xMidYMax meet"
      className="absolute inset-0 w-full h-full pointer-events-none"
      data-testid="penalty-needle"
    >
      <line x1={cx} y1={cy} x2={x} y2={y} stroke="#003366" strokeWidth={3.5} strokeLinecap="round" />
      <circle cx={cx} cy={cy} r={5} fill="#003366" />
    </svg>
  );
};

export const PenaltyGauge = ({ penaltyText }) => {
  const idx = bandIndexFromText(penaltyText);
  const display = penaltyText
    ? String(penaltyText).replace(/^Rs\s*/i, "₹").replace(/\s*Crore.*$/i, " Cr").replace(/\s*exposure.*$/i, "")
    : "—";
  return (
    <GrcCard
      title="Penalty Exposure"
      info="Potential monetary exposure under DPDP Act 2023 penalty bands, derived from the assessment's maturity and gap profile."
      infoTestId="info-penalty"
      testId="card-penalty"
    >
      <div className="relative h-28">
        <ResponsiveContainer width="100%" height="100%" minWidth={100} minHeight={80}>
          <PieChart margin={{ top: 0, bottom: 0 }}>
            <Pie
              data={BANDS.map((b) => ({ ...b, value: 1 }))}
              dataKey="value"
              cx="50%"
              cy="95%"
              startAngle={180}
              endAngle={0}
              innerRadius={48}
              outerRadius={64}
              paddingAngle={2}
              stroke="none"
              isAnimationActive={false}
            >
              {BANDS.map((b) => (
                <Cell key={b.label} fill={b.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        {idx != null && <NeedleOverlay idx={idx} />}
      </div>
      <div className="text-center mt-1">
        <div data-testid="penalty-exposure-value" className="text-xl font-bold text-[#003366]">
          {display}
        </div>
        <div className="text-xs text-slate-500">Potential Exposure</div>
        {idx != null && (
          <span
            className="inline-block mt-1.5 text-[11px] font-medium px-2 py-0.5 rounded-full"
            style={{ backgroundColor: `${BANDS[idx].color}1A`, color: BANDS[idx].color }}
            data-testid="penalty-band-badge"
          >
            {BANDS[idx].label}
          </span>
        )}
      </div>
    </GrcCard>
  );
};
